import { cn } from '@/lib/utils/cn';

export type ProfileAvatarProps = {
  avatarUrl?: string | null;
  userName?: string;
  size?: 'sm' | 'md' | 'lg' | 'xl';
  className?: string;
};

const sizeClasses = {
  sm: 'h-8 w-8 text-xs',
  md: 'h-10 w-10 text-sm',
  lg: 'h-12 w-12 text-base',
  xl: 'h-16 w-16 text-xl',
};

const getInitials = (name?: string) => {
  if (!name) {
    return '?';
  }
  const parts = name.trim().split(' ');
  if (parts.length >= 2) {
    return `${parts[0][0]}${parts[1][0]}`.toUpperCase();
  }
  return name.substring(0, 2).toUpperCase();
};

export const ProfileAvatar = ({
  avatarUrl,
  userName,
  size = 'md',
  className,
}: ProfileAvatarProps) => {
  return (
    <div
      className={cn(
        'relative overflow-hidden rounded-full border-2 border-slate-200 bg-slate-100',
        sizeClasses[size],
        className,
      )}
    >
      {avatarUrl ? (
        <img src={avatarUrl} alt={userName || 'Avatar'} className="h-full w-full object-cover" />
      ) : (
        <div className="flex h-full w-full items-center justify-center bg-gradient-to-br from-blue-500 to-purple-600 font-bold text-white">
          {getInitials(userName)}
        </div>
      )}
    </div>
  );
};
